import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import MobileIconUi from '../styles/ui/MobileIconUi'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

const PADDING_LEFT = 3
const PADDING_RIGHT = 1
const PADDING_TOP = 0
const PADDING_BOTTOM = 2

function PaddingStyle({
  padding = '0px 0px 0px 0px',
  mobilePadding = '0px 0px 0px 0px',
  ...restProps
}) {
  const { isMobile } = useDeviceModeContext()
  const currentPadding = isMobile ? mobilePadding : padding
  const update = isMobile ? restProps.mobileUpdate : restProps.update

  const getPadding = position => {
    const padding = currentPadding.split(' ')

    return Number.parseInt(padding[position], 10)
  }

  const change = positions => value => {
    const padding = currentPadding.split(' ')
    const calculatedValue = value < 0 ? 0 : value

    positions.forEach(position => {
      padding[position] = `${+calculatedValue}px`
    })

    update(padding.join(' '))
  }

  return (
    <div>
      <GroupTitle>settings_styles.padding.label</GroupTitle>
      <RangeElement
        label="Top"
        labelIcon={isMobile && <MobileIconUi />}
        value={getPadding(PADDING_TOP)}
        onChange={change([PADDING_TOP])}
        max={300}
        allowNegative={false}
      />
      <RangeElement
        label="Bottom"
        labelIcon={isMobile && <MobileIconUi />}
        value={getPadding(PADDING_BOTTOM)}
        onChange={change([PADDING_BOTTOM])}
        max={300}
        allowNegative={false}
      />
      <RangeElement
        label="left/right"
        labelIcon={isMobile && <MobileIconUi />}
        value={getPadding(PADDING_LEFT)}
        onChange={change([PADDING_LEFT, PADDING_RIGHT])}
        max={300}
        allowNegative={false}
      />
    </div>
  )
}

PaddingStyle.propTypes = {
  update: PropTypes.func.isRequired,
  mobileUpdate: PropTypes.func.isRequired,
  padding: PropTypes.string,
  mobilePadding: PropTypes.string,
}

export default memo(PaddingStyle)
